import React from 'react';
import { useSpring } from 'react-spring';
export default function(trigger: boolean) {
    return useSpring({
        transform: `rotateX(${trigger ? 180 : 0}deg`,
        config: { mass: 5, friction: 80, tension: 3000, clamp: true },
    });
}
